import { Box } from '@material-ui/core';
// import Logo from './Logo';
import logo from '../assets/images/Kocars/original.png';

const SlashScreen = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: 'background.paper',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
      left: 0,
      p: 3,
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 2000
    }}
  >
    <img
      src={logo}
      alt="logo"
      style={{ width: '50%' }}
    />
  </Box>
);

export default SlashScreen;
